(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  // Center the selected collection in the horizontal tab rail without scrolling the page.
  function centerPullCoveCollection(root = document) {
    root.querySelectorAll('[data-pc-collection-nav]').forEach((rail) => {
      const active = rail.querySelector('[aria-current="page"]');
      if (!active) return;
      const parent = rail.getBoundingClientRect();
      const item = active.getBoundingClientRect();
      rail.scrollLeft += (item.left + item.width / 2) - (parent.left + parent.width / 2);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => centerPullCoveCollection(), { once: true });
  } else {
    centerPullCoveCollection();
  }
  document.addEventListener('shopify:section:load', (event) => centerPullCoveCollection(event.target));

  } catch(e) { console.error(e); }
})();
})();
